import { render, staticRenderFns } from "./Phoenix.vue?vue&type=template&id=fe370d98&scoped=true&"
import script from "./Phoenix.vue?vue&type=script&lang=js&"
export * from "./Phoenix.vue?vue&type=script&lang=js&"
import style0 from "./Phoenix.vue?vue&type=style&index=0&id=fe370d98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe370d98",
  null
  
)

export default component.exports